import React from 'react'
import PropTypes from 'prop-types'

class BenefitSummary extends React.Component {

  constructor () {
    super ()
  }

  iconClass (benefitType) {
    const iconClassName = {
      "paid": "paid-benefit-icon",
      "job-protection": "job-protected-benefit-icon",
      "other": "benefit-icon-self additional-benefit-icon",
      "completed": "benefit-icon-self completed-icon black"
    }
    return iconClassName[ benefitType ] + " benefit-icon"
  }

  getBenefitLabel (index) {
    const labels = [
      this.props.paidLeaveSubstitution || "Paid Benefits",
      this.props.jobProtectedLeaveSubstitution || "Job Protection Benefits",
      "Additional Benefits"
    ]
    return labels[index]
  }

  getText (benefit, index) {
    const nounBenefit = this.props.pluralize("benefit", benefit.number, "noun")
    const verbProvide = this.props.pluralize("provide", benefit.number, "verb")
    const benefitSummary1 = `We have found ${benefit.number} ${nounBenefit} that potentially \
                            ${verbProvide} you ${this.getBenefitLabel(index)}`
    const benefitSummaries = [
      benefitSummary1,
      benefitSummary1,
      `We found ${benefit.number} additional ${nounBenefit} that potentially support your leave`,
      "Important tasks added to LeavePlan"
    ]

    return benefitSummaries [index]
  }

  render () {
    return (
      <div className="benefit-row">
        <div className="benefit-icon-container">
          <span className={this.iconClass(this.props.benefit.type)}>
          </span>
        </div>
        <div className="benefit-statement">
          <span>
            <strong>
              { this.getText(this.props.benefit, this.props.benefit.index) }
            </strong>
          </span>
        </div>
      </div>
    )
  }
}

BenefitSummary.propTypes = {
  benefit: PropTypes.object
}

export default BenefitSummary;
